import { ResultOf } from 'gql.tada';
import { weblinkFragment } from '../../../graphql/fragments/weblinkFragment';
import { graphql } from '../../../graphql/graphql';

export const propertyPageCtaLinkFragment = graphql(
  `
    fragment PropertyPage_CtaLink on PropertyPage_CtaLink {
      __typename
      isFeatured
      webLink {
        ...WebLink
      }
    }
  `,
  [weblinkFragment],
);

export type PropertyPageCtaLink = ResultOf<typeof propertyPageCtaLinkFragment>;
